"use client";
import { trackGA4Event } from "@/app/config/ga4";
import Image from "next/image";
import Link from "next/link";
import React, { Fragment, memo } from "react";

const BreadCrumbs = ({
  breadcrumbs,
  layoutStyle,
  activeStateStyle,
}: {
  breadcrumbs?: any[];
  layoutStyle?: object;
  activeStateStyle?: object;
}) => {
  return (
    <div
      id="breadcrumb"
      style={{
        display: "flex",
        alignItems: "ceter",
        transform: "translateX(-4px)",
      }}
    >
      {breadcrumbs?.map((data: any, idx) => {
        return (
          <Fragment key={data?.path}>
            <Link
              href={idx === breadcrumbs?.length - 1 ? "#" : data?.href}
              style={{
                padding: idx === 0 ? "4px" : "0px",
                ...layoutStyle,
                ...(idx === breadcrumbs?.length - 1 ? activeStateStyle : {}),
              }}
              onClick={() => {
                trackGA4Event("breadcrumb_click", {
                  eventAction: idx,
                  eventLabel: data?.path === "/" ? "Home" : data?.label,
                  target_url: data?.href,
                  page_name: data?.path ?? "",
                });
              }}
              prefetch={false}
            >
              {data?.path === "/" ? (
                idx === breadcrumbs?.length - 1 ? (
                  <Image
                    src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/icons/blue_home.svg`}
                    alt={"Home Button"}
                    height={18}
                    width={18}
                    aria-label="Home Page"
                  />
                ) : (
                  <Image
                    src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/icons/home.svg`}
                    alt={"Home Button"}
                    height={18}
                    width={18}
                    aria-label="Home Page"
                  />
                )
              ) : (
                <>
                  <Image
                    src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/icons/left-arrow.svg`}
                    alt={"Home Button"}
                    height={16}
                    width={16}
                    aria-label="Home Page"
                  />
                  <span
                    style={{
                      whiteSpace: "nowrap",
                      maxWidth: "58vw",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {data?.label}
                  </span>
                </>
              )}
            </Link>
          </Fragment>
        );
      })}
    </div>
  );
};

export default memo(BreadCrumbs);
